class BatchRequestItem {
  constructor ({method, url, queryParams, params, payload, axiosParams, clientParams}) {
    this.method = method;

    // remove api path from url
    this.url = url.replace('/api', '');
    this.params = params;
    this.queryParams = queryParams;
    this.payload = payload;
    this.axiosParams = axiosParams;
    this.clientParams = clientParams;

    this.resolveCallBack = null;
    this.rejectCallback = null;
    this.requestPromise = this._buildPromise();
  }

  _buildPromise () {
    return new Promise((resolve, reject) => {
      this.resolveCallBack = resolve;
      this.rejectCallback = reject;
    });
  }

  getPromise () {
    return this.requestPromise;
  }

  // make response the same structure as axios response
  wrapResponse (response) {
    if (this.method === 'POST') {
      return {
        data: response
      };
    }
    return response;
  }

  resolvePromise (response) {
    this.resolveCallBack(response);
  }

  rejectPromise (error) {
    this.rejectCallback(error);
  }

  getHeaders () {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json'
    };
    if (this.params && this.params.accountId) {
      headers['X-API-Account'] = this.params.accountId;
    }

    return headers;
  }

  getParams () {
    const params = {
      headers: this.getHeaders(),
      method: this.method,
      url: this.url
    };
    if (this.payload) {
      params.body = this.payload;
    }

    return params;
  }
}


export default BatchRequestItem;
